import React from 'react';
import { Select } from 'antd';
import { GetRequest } from './Ajax';
import { trans as _ } from './i18n';

const { Option } = Select;

export class ADWaterfallSelect extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            options: []
        };
        this.unmount = false;
        this.adWaterfallMap = {};
    };

    fetch = ()=>{
        var url = '/waterfall_list/'+this.props.product_uid+'/'+this.props.placement_uid+'?only_enable=yes';
        if (!!this.props.get_all) {
            url = '/waterfall_list'+this.props.product_uid+'/'+this.props.placement_uid;
        }
        GetRequest(url)
        .then(resp => {
            var options = [];
            if (this.props.showall==='true') {
                options.push(
                    <Option key="waterfall_all" value="">
                        {_("All")}
                    </Option>
                );
            }
            this.adWaterfallMap = {};
            for (var i in resp.data) {
                var entry = resp.data[i];
                this.adWaterfallMap[entry.id] = entry;
                options.push(
                    <Option key={entry.id} value={entry.id}>
                        {entry.name}
                    </Option>
                );
            }
            if (!this.unmount) {
                this.setState({
                    options: options
                });
            }
        });
    };

    componentDidMount(){
        this.fetch();
    };

    componentWillUnmount(){
        this.unmount = true;
    }

    handleProductChange(value){
        if (!!this.props.onChange) {
            this.props.onChange(value, this.adWaterfallMap[value]);
        }
    };

    render() {
        return (
            <Select
                {...this.props}
                showSearch
                placeholder={_("Select AD Waterfall")}
                optionFilterProp="children"
                onChange={(v)=>{this.handleProductChange(v)}}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
            >
                {this.state.options}
            </Select>
        );
    };
};
